import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
// import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#411564", // Purple
    secondary: "#F47920", // Orange
    accent: "#ECECEC", // Gray
    dark: "#424242"
  }
});
